export enum PlaylistType {
  SAME_CATEGORY_SIMILAR_OFFERS = 'sameCategorySimilarOffers',
  BOOKS_SAME_CATEGORY_SIMILAR_OFFERS = 'booksSameCategorySimilarOffers',
  OTHER_CATEGORIES_SIMILAR_OFFERS = 'otherCategoriesSimilarOffers',
  SAME_ARTIST_PLAYLIST = 'sameArtistPlaylist',
  SEARCH_RESULTS = 'searchResults',
  TOP_OFFERS = 'topOffers',
}
